module.exports = __webpack_public_path__ + "img/rod_03.8bfee28a.svg";